module.exports = __webpack_public_path__ + "img/classReport_top.785896e3.png";